import React, { useEffect, useCallback, useState } from "react";
import { orgarnizationMngtThunk } from "../../../store/actions/organizationmanagement/orgarnization.thunk";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { PageBody } from "../../../components/loader";
import { useLoadingMessage } from "../../../components/useLoadingMessage";
import { capitalize } from "../../../utils/capitalize";
import { formattCurrency } from "../../../utils/formatCurrency";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

export const ReportRequest = () => {
  const { allRequests } = useSelector((state) => state.orgarnizationMngt);
  const dispatch = useDispatch();
  const [searchRequest, setSearchRequest] = useState("");
  const { isLoading, message, updateLoader } = useLoadingMessage();

  console.log("request", allRequests);

  const getAllRequests = useCallback(async () => {
    await dispatch(orgarnizationMngtThunk.getAllRequest());
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    getAllRequests();
  }, []);
  const AllRequests = allRequests.filter((request) => {
    return (
      (request.created_by &&
        request.created_by.first_name
          .toLowerCase()
          .indexOf(searchRequest.toLowerCase()) !== -1) ||
      request.request_type.name
        .toLowerCase()
        .indexOf(searchRequest.toLowerCase()) !== -1 ||
      (request.request_category &&
        request.request_category.name
          .toLowerCase()
          .indexOf(searchRequest.toLowerCase()) !== -1)
    );
  });
  return (
    <React.Fragment>
      <PageBody isLoading={isLoading} message={message}>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box-two">
                  <h4 className="page-title"></h4>
                  <h1 className="welcome_text">REPORT MANAGEMENT</h1>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className=" table-responsive">
                  <div className="table-title">
                    <div className="row">
                      <div className="col-sm-6">
                        <h2>
                          <b> REQUEST SUMMARY </b>{" "}
                        </h2>
                      </div>
                      <div className="col-sm-6">
                        <Link to="/dashboard/report" className="btn  p-3">
                          <span class="fa fa-arrow-left"></span>&nbsp;Back&nbsp;
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-xs-12">
                      <div className="">
                        <div className="mb-3 clearfix">
                          <div
                            class="btn-group float-left"
                            role="group"
                            aria-label="Basic example"
                          >
                            <button
                              type="button"
                              class="btn btn-secondary btn-group-sm"
                              onClick={() => window.print()}
                            >
                              Print
                            </button>
                            <ReactHTMLTableToExcel
                              id="test-table-xls-button"
                              className="btn btn-secondary btn-group-sm"
                              table="report-request"
                              filename="REQUEST SUMMARY"
                              sheet="tablexls"
                              buttonText="Export to excel"
                            />
                          </div>

                          <form class="form-inline my-2 my-lg-0 float-right">
                            <input
                              class="form-control mr-sm-2"
                              type="search"
                              placeholder="Search"
                              aria-label="Search"
                              name="search"
                              value={searchRequest}
                              onChange={(e) => setSearchRequest(e.target.value)}
                            />{" "}
                          </form>
                        </div>
                      </div>
                      <div className="" id="printTable">
                        <table
                          className="table table-striped table-hover"
                          id="report-request"
                        >
                          {AllRequests < 1 ? (
                            <div className="text-center m-auto">
                              <h1 className="text-dark">No record found</h1>
                            </div>
                          ) : (
                            <thead>
                              <tr>
                                <th>SN</th>
                                <th>Employee Name</th>
                                <th>Request Type </th>
                                <th>Sub Category</th>
                                <th>Description</th>
                                <th>Price</th>
                                <th>Date Requested</th>
                                <th>Date Approved</th>
                                <th>Approved By</th>

                                <th>Status</th>
                              </tr>
                            </thead>
                          )}
                          <tbody>
                            {AllRequests.map((request, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>
                                  {capitalize(request.created_by.first_name) +
                                    " " +
                                    capitalize(request.created_by.last_name)}
                                </td>
                                <td>{capitalize(request.request_type.name)}</td>
                                <td>
                                  {request.request_category
                                    ? capitalize(request.request_category.name)
                                    : null}
                                </td>
                                <td>{capitalize(request.description)}</td>
                                <td>₦ {formattCurrency(request.price)}</td>
                                <td>
                                  {moment(request.created_at).format("ll")}
                                </td>
                                <td>
                                  {request.approved_on
                                    ? moment(request.approved_on).format("ll")
                                    : null}
                                </td>
                                <td>
                                  {request.approved_by
                                    ? capitalize(request.approved_by.first_name)
                                    : null}
                                </td>

                                <td>
                                  {request.status === 1 ? (
                                    <label
                                      style={{
                                        color: "orange",
                                      }}
                                    >
                                      PENDING
                                    </label>
                                  ) : null}
                                  {request.status === 2 ? (
                                    <label
                                      style={{
                                        color: "green",
                                      }}
                                    >
                                      APPROVED
                                    </label>
                                  ) : null}
                                  {request.status === 3 ? (
                                    <label
                                      style={{
                                        color: "darkred",
                                      }}
                                    >
                                      REJECTED
                                    </label>
                                  ) : null}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <nav aria-label="...">
                          <ul class="pagination">
                            <li class="page-item disabled">
                              <a
                                class="page-link"
                                href="#"
                                tabindex="-1"
                                aria-disabled="true"
                              >
                                Previous
                              </a>
                            </li>
                            <li class="page-item">
                              <a class="page-link">1</a>
                            </li>
                            <li class="page-item active" aria-current="page">
                              <a class="page-link" href="#">
                                2
                              </a>
                            </li>
                            <li class="page-item">
                              <a class="page-link" href="#">
                                3
                              </a>
                            </li>
                            <li class="page-item">
                              <a class="page-link" href="#">
                                Next
                              </a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageBody>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/reportmanagement/repuest_list.js